import React from "react";

import { chartColors } from "../../../config/colors";

interface HeaderProps {
  title: string;
  description?: string;
  scalingFactor?: number;
  transform?: string;
}

export const Header: React.FC<HeaderProps> = ({
  title,
  description,
  scalingFactor = 1,
  transform,
}) => {
  return (
    <g className="header" transform={transform}>
      <text
        x="0"
        y={13 * scalingFactor}
        fontFamily="TheMixExtraBold, sans-serif"
        fontWeight="700"
        fontSize={20 * scalingFactor}
        fill={chartColors.black}
      >
        {title.split("\n").map((titlePart, index) => (
          <tspan key={index} x="0" dy={`${1.3 * index}em`}>
            {titlePart}
          </tspan>
        ))}
      </text>
      {description && (
        <text
          x="0"
          y={38 * scalingFactor}
          fontSize={14 * scalingFactor}
          fill={chartColors.fontPrimary}
        >
          {description.split("\n").map((descPart, index) => (
            <tspan key={index} x="0" dy={`${1.3 * index}em`}>
              {descPart}
            </tspan>
          ))}
        </text>
      )}
    </g>
  );
};
